import { useEffect, useState } from 'react';

/** `value`, once it has held still for `delayMs`. Starts at the first value without waiting. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timeoutId = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timeoutId);
    }, [value, delayMs]);
    return debounced;
}
